export default __webpack_public_path__ + "4189af7d585db7e4c34e4fc02a5dd2c3.svg";